export default function stripslashes(str) {
  let r = (str) ? str.replaceAll(/\\(.)/mg, '$1') : ''
  return r
}

export const generateSlug = ( str ) => {
  const rtn = str.replaceAll(' ', '_').toLowerCase()
  return rtn
}

export const replaceSpecials = function (input){
  // console.log(subcate)
  const rtn = input.replaceAll(' ', '_')
    .replaceAll('\'', '_')
    .replaceAll('"', '_')
    .replaceAll('+', '_')
    .replaceAll('/', '_')
    .replaceAll('?', '_')
    .toLowerCase()
  return rtn
}

export const formatYen =  function(price){
  const taxed = price * 1.1
  const r = '¥' + new Intl.NumberFormat().format(taxed) 
  return r
}

export const filterOnlyUnique = function(value, index, self) {
  return self.indexOf(value) === index
}

export const replaceS3path = (str) => {
  const find_to_replace = 'img.aandf.co.jp.s3.amazonaws.com'
  const text_to_replace = 'img.aandf.co.jp'
  let rtn = str.replaceAll(find_to_replace, text_to_replace)
  if( rtn.substring(0,2) == '//' )  rtn = 'https:' + rtn
  return rtn
}

export const removeLineBreaks = (str) => {
  const rtn = (str) ? str.replace(/(\r\n|\n|\r)/gm, '') : ''
  return rtn
}
export const nl2br = (str, replaceMode, isXhtml)  =>{
  var breakTag = (isXhtml) ? '<br />' : '<br>'
  var replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2'
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr)
}
export const  br2nl = (str, replaceMode) => {   
  var replaceStr = (replaceMode) ? '\n' : ''
  return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr)
}
export const removeTag = (str) => {
  const find_to_replace = /<("[^"]*"|'[^']*'|[^'">])*>/g
  const text_to_replace = ''
  const rtn = str.replace(find_to_replace, text_to_replace)
  return rtn
}

export const formatDate = (str) => {
  const find_to_replace = /-/g
  const text_to_replace = '.'
  const new_str = str.replace(find_to_replace, text_to_replace)
  const arr = new_str.split(' ')
  const rtn = arr[0]
  return rtn
}

export const addBR = (originalText, textBeforeBR) => {
  return originalText.replace(textBeforeBR, textBeforeBR+'<br>')
}

export const removeEmptyFromArray = (arr) => {
  const new_arr = arr.filter(function(x){
    return !(x === null || x === undefined || x === '')
  })
  return new_arr
}

export const filterArrayBySlugs = (items, slugs, key) => {
  const result = items.filter((item) => slugs.filter((slug) => slug === item[key]).length > 0)
  return result
}

export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export const setCookie = (name, data, period) => {
  const cookies = name + '=' + JSON.stringify(data) + ';' + 'path=/ ;' + 'max-age=' + period + ';'
  document.cookie = cookies
}

export const getCookie = (name) => {
  const cookies = document.cookie
  if(cookies){
    const result = cookies.split(';').find((item) => item.trim().startsWith(`${name}=`))
    if(result){
      return JSON.parse(result.replace(`${name}=`, ''))
    }
  }
}

export const removeDuplicatesFromArray = array => [...new Set(array)]

export const removeEmptyValueFromArray = array => array.filter(Boolean)

export const removeDuplicatesAndEmpty = (array) => {
  return removeEmptyValueFromArray(removeDuplicatesFromArray(array))
}

export const getGoogleMapURL = (name, longtitude, langtitude) => {
  return 'https://www.google.co.jp/maps/search/' + name + '/@' + longtitude+ ',' + langtitude + ',17z'
}

export const getGoogleMapURL2 = (name) => {
  return 'https://www.google.com/maps/search/?api=1&query=' + name.replace('&', '%26')
}

export const hasTouchScreen = () => {
  if (typeof window === 'undefined') return
  if (navigator.maxTouchPoints > 0) return true
  if (navigator.msMaxTouchPoints > 0) return true
  if (window.matchMedia('(pointer:coarse)').matches) return true
  // if ('orientation' in window) return true
  return false
}